import PrecipitacionRepository from '@/services/PrecipitacionRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    listaPrecipitacion: [],
  },
  getters: {
    getPrecipitacion: (state) => (idPrecipitacion) => {
      return state.listaPrecipitacion.find(precipitacion => precipitacion.idPrecipitacion === idPrecipitacion)
    },
  },
  mutations: {
    setListaPrecipitacion(state, listaPrecipitacion) {
      state.listaPrecipitacion = listaPrecipitacion.map(precipitacion => {
        precipitacion.fechaFormated = Vue.filter('fhDate')(precipitacion.fecha)
        precipitacion.cantidadFormated = Vue.filter('fhNumber')(precipitacion.cantidad)
        return precipitacion
      })
    },

    clearPrecipitacion(state) {
      state.listaPrecipitacion = []
    },
  },
  actions: {
    async fetchListaPrecipitacion({state, commit, rootState}) {
      if (state.listaPrecipitacion && state.listaPrecipitacion.length > 0) {
        return
      }

      let idFichaAgricola = rootState.fichas.fichaAgricola.idFichaAgricola

      let listaPrecipitacion = await PrecipitacionRepository.listaPrecipitacion(idFichaAgricola) || []
      commit('setListaPrecipitacion', listaPrecipitacion)
    },

    clearPrecipitacion({commit}) {
      commit('clearPrecipitacion')
    },
  }
}
